import FEBottomSheet from '../FEBottomSheet';
import { FESegmentedControl } from '..';
import FESegmentedBottomSheetProps from './props';
import style from './style.module.css';

const FESegmentedBottomSheet = <T extends string>({
  open,
  onClose,
  closeOnOverlayClick,
  items,
  onChange,
  value,
  render,
}: FESegmentedBottomSheetProps<T>) => (
  <FEBottomSheet
    closeOnOverlayClick={closeOnOverlayClick}
    onClose={onClose}
    open={open}
    render={({ onClose }) => (
      <>
        <div className={style.header}>
          <FESegmentedControl {...{ items, onChange, value }} />
        </div>
        <>{render({ onClose, value })}</>
      </>
    )}
  />
);

export default FESegmentedBottomSheet;
export type { FESegmentedBottomSheetProps };
